import { Row } from "style/preset"
import StyledContainer from "style/styledContainer"
import styled, { css } from "styled-components"

import { ReactComponent as SwapSvg} from "assets/svgs/swap_icon.svg"
import { ReactComponent as DisconnectWalletSvg } from "assets/svgs/disconnect.svg"

import { ReactComponent as ArrowRight2Svg } from "assets/svgs/arrow_right_2.svg"
import useMainBtn from "hooks/useMainBtn"
import { useCallback } from "react"
import { getIconUrl } from "utils"
import CImage from "./CImage"
import DrawerSlippageCom from "./Drawer/DrawerSlippageCom"
import { useAppDispatch, useAppSelector } from "hooks/redux/hooks"
import { setOpenSlippageWin } from "hooks/redux/slices/appSlice"

const MainBtnCom = () => {
    const { openSlippageWin } = useAppSelector((state) => state.app)
    const { btnText, btnActive, btnStatus, fromChain, btnHandler } = useMainBtn()
    const dispatch = useAppDispatch()

    const getIconNode = useCallback(() => {
        if(btnStatus === -1) {
            return <DisconnectWalletSvgWrap></DisconnectWalletSvgWrap>
        } else if(btnStatus === -7) {
            return <ChainIconWrap>
                <CImage width="100%" height="100%" src={getIconUrl(fromChain?.chainIndex, 'chain')}></CImage>
            </ChainIconWrap>
        } else {
            return <SwapSvgWrap></SwapSvgWrap>
        }
    }, [btnStatus, fromChain?.chainIndex])

    return <StyledContainer>
        <MainBtnwrap $active={btnActive} onClick={() => btnHandler()}>
            <Row>
                {
                    getIconNode()
                }
                <BtnTitleWrap>{btnText}</BtnTitleWrap>
                <StyledContainer $width="24px"></StyledContainer>
                {/* <SlippageWarnCom btnFlag={true}></SlippageWarnCom> */}
            </Row>
            <ArrowRight2SvgWrap></ArrowRight2SvgWrap>
        </MainBtnwrap>

        <DrawerSlippageCom open={openSlippageWin} closeChange={(isClosed) => dispatch(setOpenSlippageWin(isClosed))} onComplete={() => btnHandler('slippage')}></DrawerSlippageCom>
    </StyledContainer>
    
}

const BtnTitleWrap = styled(StyledContainer)`
    font-family: RoobertSemiBold;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px;
    color: ${({theme}) => theme.basicWhite};
    margin-left: 14px;

`

const SwapSvgWrap = styled(SwapSvg)`
    width: 20px;
    height: 20px;
`

const ArrowRight2SvgWrap = styled(ArrowRight2Svg)`
    width: 16px;
    height: 16px;
`
const DisconnectWalletSvgWrap = styled(DisconnectWalletSvg)`
    width: 20px;
    height: 20px;
`

const ChainIconWrap = styled(StyledContainer)`
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background-color: #0A0A0A;
    border: 1px solid #fff;
`

const MainBtnwrap = styled(StyledContainer)<{$active: boolean}>`
    padding: 20px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    transition: background-color 0.5s;

    ${
        ({$active}) => $active ? css`
            background: olive linear-gradient(99deg, #4D1DF7, #3508D9);
            ${BtnTitleWrap} {
                color: ${({theme}) => theme.basicWhite};
            }
            ${SwapSvgWrap} {
                path {
                    fill: ${({theme}) => theme.basicWhite};
                }
            }
            ${ArrowRight2SvgWrap} {
                path {
                    fill: ${({theme}) => theme.basicWhite};
                }
            }
            
            &:hover {
                box-shadow: 0px 10px 32px -4px rgba(53, 8, 217, 0.10), 0px 6px 14px -6px rgba(53, 8, 217, 0.12);
            }
        ` : css`
            cursor: not-allowed;
            background-color: #F6F5F4;
            ${BtnTitleWrap} {
                color: #CACCCE;
            }
            ${SwapSvgWrap} {
                path {
                    fill: #CACCCE;
                }
            }
            ${ArrowRight2SvgWrap} {
                path {
                    fill: #CACCCE;
                }
            }
        ` 
    }
`

export default MainBtnCom